import React, { useEffect } from 'react';

import ImageBox from './imagebox';
import IntroBoxText from './introbox';
import SectionBox from './section';

const Products = ({ content, location, scrollToTag }) => {

    useEffect(() =>{
        scrollToTag(location)
    }, [location, scrollToTag]);

    return (
        <div className="products-pg">
            {/* Alternate image and info section start */ }
            <div className="alternateImageInfo-box">
                {
                    content && !!content.product_section.length && content.product_section.map((obj, index) => {
                        return <SectionBox id={ obj.section_id } index={ index } key={ index }>
                            {/* image section start */ }
                            <ImageBox
                                image={ `url(${obj.one_side_image && obj.one_side_image.url})` }
                                className={ index % 2 === 0 ? "slide-right" : "slide-left" }
                            />
                            {/* image section end */ }

                            {/* information section start */ }
                            <div className="box-12 box-md-6 info-box">
                                <IntroBoxText
                                    className={ index % 2 === 0 ? "slide-left" : "slide-right" }
                                    title={ obj.one_side_title || '' }
                                    para={ obj.one_side_content || '' }
                                />
                            </div>
                            {/* information section end */ }

                            {/* relatedCard section start */ }
                            <div className={ `box-12 relatedCard-box ${index === content.product_section.length - 1 ? 'large-Column' : ''}` }>
                                <div className="container">
                                    <div className={ `row-wrap cardlist column-${obj.block_section.length}` }>
                                        {
                                            !!obj.block_section.length && obj.block_section.map((block, blockIndex) => {
                                                return (
                                                    <div className="item-box" key={ blockIndex }>
                                                        <div className="card customAnim slide-top">
                                                            <div className="inner-box">
                                                                <div className="divider-box" style={ { 'height': '3px' } }>
                                                                    <span className='line'></span>
                                                                </div>
                                                                {
                                                                    block.title &&
                                                                    <h6>{ block.title }</h6>
                                                                }
                                                                {
                                                                    block.content && <div dangerouslySetInnerHTML={ { __html: block.content } } />
                                                                }

                                                                { block.image && <div className="imgBox">
                                                                    <img src={ block.image.url } alt='money icon'/>
                                                                </div> }

                                                            </div>
                                                        </div>

                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    { obj.feature_section &&
                                            <div className="feature-section-container">
                                                { obj.feature_section.map((block, blockIndex) => {
                                                    return (
                                                        <div className="feature-section-block customAnim slide-top" key={blockIndex}>
                                                            <span className="feature-section-title">{block.title}</span>
                                                            <div className="feature-section-content" dangerouslySetInnerHTML={{ __html: block.content}} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                    }
                                </div>
                            </div>
                            {/* relatedCard section end */ }
                        </SectionBox>;
                    })
                }
            </div>
            {/* Alternate image and info section end*/ }

        </div>
    );
};

export default Products;


// const duimmy = () => {
//     return <>
//         {/* section 1 start */ }
//         <SectionBox id="iban" index={ 0 }>
//             {/* image section start */ }
//             <ImageBox
//                 image={ `url(${process.env.PUBLIC_URL}/images/illustrations/iban_cover.svg)` }
//                 className="slide-right"
//             />
//             {/* image section end */ }

//             {/* information section start */ }
//             <div className="box-12 box-md-6 info-box">
//                 <IntroBoxText
//                     className="slide-left"
//                     title="Get the Demivolt IBAN Account"
//                     para="Do you have a business that serves EU clients and would it benefit from having a European bank account? Our IBAN solution gives you a fully-operational European bank account."
//                 />
//             </div>
//             {/* information section end */ }

//             {/* relatedCard section start */ }
//             <div className="box-12 relatedCard-box">
//                 <div className="container">
//                     <div className="row-wrap cardlist column-3">
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <h6>Manage Your Funds Digitally</h6>
//                                     <p>Your Demivolt IBAN account gives you all the benefits of a European bank account from anywhere in the world, hence, being located outside the EU should no longer be a barrier to your business operations.</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <h6>Do You Want Multiple IBAN Accounts?</h6>
//                                     <p>We understand that you might need more than one account, which is why you can get up to 3 unique IBAN numbers as a verfied Demivolt customer. <a href="#!">Terms & Conditions</a> apply.</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <h6>Do You Handle Payments in Multiple Currencies?</h6>
//                                     <p>As a global business, we know that your clients may prefer to pay using different currencies, which is why your Demivolt account allows you to make and accept payments in the following major currencies: USD, EUR and GBP.</p>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* relatedCard section end */ }
//         </SectionBox>

//         {/* section 1 end */ }

//         {/* section 2 start */ }
//         <SectionBox id="sepa-payments" index={ 1 }>
//             {/* image section start */ }
//             <ImageBox
//                 image={ `url(${process.env.PUBLIC_URL}/images/illustrations/fast_payments_cover.svg)` }
//                 className="slide-left"
//             />
//             {/* image section end */ }
//             {/* information section start */ }
//             <div className="box-12 box-md-6 info-box">
//                 <IntroBoxText
//                     className="slide-right"
//                     title="Make Fast EU Payments"
//                     para="Your Demivolt account gives you access to Single Euro Payments Area (SEPA) network, allowing you to send euro-denominated payments across the Eurozone at low costs."
//                 />
//             </div>
//             {/* information section end */ }


//             {/* relatedCard section start */ }
//             <div className="box-12 relatedCard-box">
//                 <div className="container">
//                     <div className="row-wrap cardlist column-4">

//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>Such transactions will reach the recipient on the next business day latest.</p>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>SEPA payments only work for Euro-denominated payments sent and received within Europe.</p>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>You can also make payments to countries outside the EU region, however those will be treated as international payments.</p>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>Payments made in currencies other than the Euro, but sent across the EU, cannot be settled via SEPA payments.</p>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//             {/* relatedCard section end */ }
//         </SectionBox >
//         {/* section 2 end */ }


//         {/* section 3 start */ }
//         <SectionBox id="international-payments" index={ 2 }>
//             {/* image section start */ }
//             <ImageBox
//                 image={ `url(${process.env.PUBLIC_URL}/images/illustrations/global_transactions_cover.svg)` }
//                 className="slide-right"
//             />
//             {/* image section end */ }

//             {/* information section start */ }
//             <div className="box-12 box-md-6 info-box">
//                 <div className="inner-box">
//                     <IntroBoxText
//                         className="slide-left"
//                         title="Seamless Global Transactions"
//                         para="We understand the global and interconnected nature of today's world, which is why we are committed to facilitating seamless financial transactions for your company on a global scale."
//                     />
//                 </div>
//             </div>
//             {/* information section end */ }

//             {/* relatedCard section start */ }
//             <div className="box-12 relatedCard-box">
//                 <div className="container">
//                     <div className="row-wrap cardlist column-3">
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>Your Demivolt account allows you to send or receive money in EUR, USD, or GBP securely and cost-effectively.</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>We offer very competitive foreign exchange rates that will keep your costs low, allowing your money to go further.</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>With our transparent pricing structure, you can transact confidently knowing that there are no hidden charges.</p>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* relatedCard section end */ }
//         </SectionBox>
//         {/* section 3 end */ }


//         {/* section 4 start */ }
//         <SectionBox id="foreign-exchange" index={ 3 }>
//             {/* image section start */ }
//             <ImageBox
//                 image={ `url(${process.env.PUBLIC_URL}/images/illustrations/fx_cover.svg)` }
//                 className="slide-left"
//             />
//             {/* image section end */ }

//             {/* information section start */ }
//             <div className="box-12 box-md-6 info-box">
//                 <div className="inner-box">
//                     <IntroBoxText
//                         className="slide-right"
//                         title="Real-Time Interbank FX Rates"
//                         para="Your Demivolt multi-currency account displays the current FX rates in real-time."
//                     />
//                 </div>
//             </div>
//             {/* information section end */ }

//             {/* relatedCard section start */ }
//             <div className="box-12 relatedCard-box">
//                 <div className="container">
//                     <div className="row-wrap cardlist column-3">
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>We will always strive to give you the best FX rates possible based on our strong interbank network.</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>We understand the difference that a few cents can make to businesses with large transactions.</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <p>The exchange rates can be the difference between profits and losses.</p>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* relatedCard section end */ }
//         </SectionBox>
//         {/* section 4 end */ }

//         {/* section 5 start */ }
//         <SectionBox id="payment-gateway" index={ 4 }>
//             {/* image section start */ }
//             <ImageBox
//                 image={ `url(${process.env.PUBLIC_URL}/images/illustrations/payment_gateway_cover.svg)` }
//                 className="slide-right"
//             />
//             {/* image section end */ }

//             {/* information section start */ }
//             <div className="box-12 box-md-6 info-box">
//                 <div className="inner-box">
//                     <IntroBoxText
//                         className="slide-left"
//                         title="Does Your Business Need a Payment Gateway?"
//                         para="Looking for an all-in-one payments package so that you can sell online? We get it, which is why we designed a modern payment gateway that allows you to accept online payments from anywhere with greater flexibility, security and ease."
//                     />
//                 </div>
//             </div>
//             {/* information section end */ }

//             {/* relatedCard section start */ }
//             <div className="box-12 relatedCard-box large-Column">
//                 <div className="container">
//                     <div className="row-wrap cardlist column-2">
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <h6>Are You Worried About Missing Client Payments?</h6>
//                                     <p>Worry no more because the <a href="#">Demivolt</a> payments gateway guarantees 99.99% uptime, reducing the chances that you will miss a client payment to almost zero. Our gateway works quietly in the background to keep your business running smoothly.</p>

//                                     <div className="imgBox">
//                                         <img src={ `${process.env.PUBLIC_URL}/images/white_logo_stroke.svg` } />
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="item-box">
//                             <div className="card customAnim slide-top is-animate">
//                                 <div className="inner-box">
//                                     <div className="divider-box" style={ { 'height': '3px' } }>
//                                         <span className='line'></span>
//                                     </div>
//                                     <h6>Are You Wondering What Types of Payments We Process?</h6>
//                                     <ul>
//                                         <li>Firstly, we provide a routing system for all payments to land in your <a href="#">Demivolt</a> accounts.</li>
//                                         <li>You can also setup recurrent billing for your clients to maximise the lifetime value of your clients.</li>
//                                         <li>We allow multi-currency processing for your international sales, ensuring that you never miss a sale.</li>
//                                         <li>Our platform has a dispute management feature that allows for fast dispute resolution combined with fast processing of chargebacks.</li>
//                                         <li>Our intelligent reports will always keep you updated on your finances.</li>
//                                     </ul>
//                                 </div>
//                             </div>

//                         </div>

//                     </div>
//                 </div>
//             </div>
//             {/* relatedCard section end */ }
//         </SectionBox>
//         {/* section 5 end */ }
//     </>;
// };